module.exports = __webpack_public_path__ + "img/reset_sensor_step_2.e8d3bf3a.png";